import { useSelector } from "react-redux";
import { Box, Typography, Button, List, Divider, Grid } from "@mui/material";
import { Add, Remove } from "@mui/icons-material";

import { colors, alphaVar } from "../../../../../../../../ui/colors";
import { useAreaActions } from "../hooks/useAreaActions";
import { TaskSwitch } from "./tasks/TaskSwitch";
import { selectAreaByUid } from "../../../../../../../../../redux/features/quotes/quote-create-advanced/selectors/sectorWorkflowSelectors";

export const AreaModal = ({ areaUid }) => {
  const { changeQuantity, toggleTask } = useAreaActions();
  const current = useSelector(selectAreaByUid(areaUid));

  if (!current) {
    return (
      <Box p={3}>
        <Typography>No area data found.</Typography>
      </Box>
    );
  }

  const quantity = Number(current?.squareFootages[0]?.quantity) || 0;

  const tasks = Array.isArray(current.tasks) ? current.tasks : [];

  const safeDescription = current?.description?.split?.("@")?.[0] || "No description available for this area.";

  const handleDecrease = () => {
    if (quantity === 0) return;
    changeQuantity(current.uid, -1);
  };

  const handleIncrease = () => {
    changeQuantity(current.uid, +1);
  };

  const handleToggleTask = (taskUid) => {
    toggleTask(current.uid, taskUid);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",

        borderRadius: 3,
        p: 3,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography variant="h5" fontWeight={700} color={colors.gray[800]} textAlign="center" sx={{ mb: 3 }}>
        {current.name}
      </Typography>

      <Grid container spacing={2}>
        <Box
          component="img"
          src={current?.imageUrl}
          alt={current.name}
          sx={{
            width: "100%",
            height: 300,
            objectFit: "contain",
          }}
        />

        <Typography variant="body2" color={colors.gray[600]} sx={{ lineHeight: 1.6, margin: "auto ", maxWidth: 450 }}>
          {/*safeDescription*/}
        </Typography>

        <Grid item xs={12} display="flex" alignItems="center" justifyContent="center" mt={2}>
          <Button
            onClick={handleDecrease}
            disabled={quantity === 0}
            sx={{
              minWidth: 50,
              height: 50,
              borderRadius: "50%",
              color: quantity === 0 ? colors.gray[300] : colors.orange.base,
              border: `1px solid ${alphaVar(colors.orange.base, 0.3)}`,
              "&:hover": { backgroundColor: alphaVar(colors.orange[100], 0.1) },
            }}
          >
            <Remove />
          </Button>

          <Typography
            variant="h5"
            fontWeight={700}
            sx={{
              width: 60,
              textAlign: "center",
              color: colors.gray[700],
              mx: 2,
            }}
          >
            {quantity}
          </Typography>

          <Button
            onClick={handleIncrease}
            sx={{
              minWidth: 50,
              height: 50,
              borderRadius: "50%",
              color: colors.orange.base,
              border: `1px solid ${alphaVar(colors.orange.base, 0.3)}`,
              "&:hover": { backgroundColor: alphaVar(colors.orange[100], 0.1) },
            }}
          >
            <Add />
          </Button>
        </Grid>

        <Grid item xs={12} mt={2}>
          <Divider sx={{ mb: 1 }} />

          {/* si no tiene tareas, no mostrar  la lista de tareas*/}
          {tasks.length > 0 ? (
            <>
              <Typography variant="subtitle1" fontWeight={600} color={colors.gray[700]} sx={{ mb: 1 }}>
                Tasks included:
              </Typography>

              <List dense sx={{ height: "100%", width: "100%" }}>
                {tasks.map((task) => {
                  const tid = String(task.uid ?? task.id);
                  const checked = !!task.active;

                  return (
                    <TaskSwitch
                      key={tid}
                      task={task}
                      checked={checked}
                      disabled={quantity === 0}
                      quantity={quantity}
                      areaUid={current.uid}
                      onToggle={() => handleToggleTask(tid)}
                    />
                  );
                })}
              </List>
            </>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};
